import request from '../router/axios'

// 默认的
const loginuserid = 'e1320d1ebc224679b22fc1607d03bda7';
const projectId = '6f835ebee23a43d98b1f32c69eaf9e7d';
// ~~~~~~~~~~~~~~~~~全国屏接口~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// 初始化token
export function getInitAccessToken(data) {
    return request({
        url: `/holdMy/getInitAccessToken`,
        method: 'post',
        headers: {
            isToken: false
        },
        data: data
    })
}

// 刷新token
export function getAccessToken(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/holdMy/getAccessToken`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取城市信息
export function transportTodayByCity(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/transportTodayByCity`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取车辆个数
export function totalBranch(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/totalBranch`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

//平台企业(家)
export function totalCompany(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/totalCompany`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

//活跃司机(人)
export function totalDriver(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/totalDriver`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

//平台工地(个)(项目)
export function totalSubitem(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/totalSubitem`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取卸点
export function totalChecklist(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/totalChecklist`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取总订单数&总金额
export function getRequireCountAndTotalAmount(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/getRequireCountAndTotalAmount`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 交易统计信息
export function transferInvoice(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/transferInvoice`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}
// 运输

export function transportTotal(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/transportTotal`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 城市运营
export function transportTotalByCity(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/transportTotalByCity`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取现场图片
export function newestAttachment(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/newestAttachment`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}


// 获取理管机械(辆),活跃工地(人),入网机械(人)
export function universalQueryResult(name) {
    var data = {
        'jsonStr': JSON.stringify({
            type: "2",// 传入用户id
            loginId: loginuserid,
            name: name,
        }),
        userId: loginuserid
    }
    return request({
        url: `/sys/universalQueryResult`,
        method: 'post',
        headers: {
            serialize: true,
        },
        data: data
    })
}

// 获取今日运输
export function transferTimeLine(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/transferTimeLine`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取今日运输
export function transferTimeLine1(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/getTransportNumByDay`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取城市总运输
export function cityTransportTotal(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/cityTransportTotal`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}
// 获取根据城市名获取城市信息
export function cityTransportBySubItem(data) {
    data.userId = loginuserid;
    data.loginId = loginuserid;
    return request({
        url: `/bigData/cityTransportBySubItem`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

//~~~~~~~~~~~~~~~~~~~~~结束~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


// ~~~~~~~~~~~~~~~~~~~~城市接口~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// 获取运单统计
export function getTransportOrderStatistics(data) {
    return request({
        url: `/LargeScreenImpl/getTransportOrderStatistics`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取订单统计
export function getTransportRequireStatistics(data) {
    return request({
        url: `/LargeScreenImpl/getTransportRequireStatistics`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取订单统计
export function getSettlementOrderStatistics(data) {
    return request({
        url: `/LargeScreenImpl/getSettlementOrderStatistics`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取车队统计
export function getFleetStatistics(data) {
    return request({
        url: `/LargeScreenImpl/getFleetStatistics`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取运营消息
export function getOperateList(data) {
    return request({
        url: `/LargeScreenImpl/getOperateList`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取系统统计
export function getSystemTotalMsg(data) {
    return request({
        url: `/LargeScreenImpl/getSystemTotalMsg`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}
// 获取业务统计
export function getBusinessTotalMsg(data) {
    return request({
        url: `/LargeScreenImpl/getBusinessTotalMsg`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 获取系统消息列表 /  获取业务消息列表
export function getSystemMsg(data) {
    return request({
        url: `/LargeScreenImpl/getSystemMsg`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}
// 项目统计总计
export function subitemStatisticsNow(data) {
    return request({
        url: `/bigData/subitemStatisticsNow`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 项目统计top5
export function subitemTopFiveNow(data) {
    return request({
        url: `/bigData/subitemTopFiveNow`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}
// 1、获取平台车辆
export function getPlatformCar(data) {
    return request({
        url: `/sys/universalQueryResult`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 2、 获取装点卸点
export function querySubitemCheckitem(data) {
    data.projectId = projectId;
    return request({
        url: `/pcBaseData/querySubitemCheckitem`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 2、 获取装点卸点对应列表
export function getSubItemAndCheckItemListByCity(data) {
    return request({
        url: `/pcBaseData/getSubItemAndCheckItemListByCity`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}


// 获取运单统计
export function getSupplyChain(data) {
    return request({
        url: `/LargeScreenImpl/getSupplyChain`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}

// 实时交易
export function realTimeTradingStatistics(data) {
    return request({
        url: `/LargeScreenImpl/realTimeTradingStatistics`,
        method: 'post',
        headers: {
            serialize: true
        },
        data: data
    })
}